module.exports = __webpack_public_path__ + "assets/img/1ca104cb14a2102faf428df67280f3e5.png";